import { ImageScaleView, ViewOpts } from '@play-co/timestep-core/ui';
import { DOWNSCALE_FACTOR } from 'src/conf/scale';
import { PetSpeciesID } from 'src/replicant/pet';

export class SpeciesAvatar extends ImageScaleView {
  private speciesIcon: ImageScaleView;

  constructor(opts: ViewOpts & { species?: PetSpeciesID }) {
    super({
      image: 'assets/ui/shared/frames/backdrop_panel.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 30, right: 30 },
        vertical: { top: 30, bottom: 30 },
      },
      width: 130,
      height: 130,
      imgScale: DOWNSCALE_FACTOR,
      ...opts,
    });

    this.speciesIcon = new ImageScaleView({
      superview: this,
      width: this.style.width - 10,
      height: this.style.height - 10,
      x: 5,
      y: 5,
      scaleMethod: 'contain',
    });

    if (opts.species) {
      this.setSpecies(opts.species);
    }
  }

  public setSpecies(species: PetSpeciesID) {
    this.speciesIcon.updateOpts({
      image: `assets/species/${species}/icon.png`,
    });
  }
}
